import type { Entity } from '@backstage/catalog-model';
import { PartsCard, isKind } from './PartsCard';

/** Whether the entity is a System. */
export const isSystem = (entity: Entity): boolean => isKind(entity, 'system');

export const SystemComponentsCard = () => (
  <PartsCard
    title="Components"
    emptyText="No components in this system yet."
    showKind
  />
);
